webpackJsonp([246384609461072],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(91));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = {
	  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
	  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;
	
	  var proto = obj;
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.REPLACE });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';
	
	  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var store = createStore.apply(undefined, args);
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(undefined, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	function isCrushed() {}
	
	if (false) {
	  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = createStore;
	exports.combineReducers = combineReducers;
	exports.bindActionCreators = bindActionCreators;
	exports.applyMiddleware = applyMiddleware;
	exports.compose = compose;
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(33);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(72);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(111);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(88);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(29);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(74);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var IMAGE_POPUP_OPEN = exports.IMAGE_POPUP_OPEN = 'IMAGE_POPUP_OPEN';
	var IMAGE_POPUP_CLOSE = exports.IMAGE_POPUP_CLOSE = 'IMAGE_POPUP_CLOSE';

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(81);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(26);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(82);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.closeImagePopupAction = exports.openImagePopupAction = undefined;
	
	var _constants = __webpack_require__(35);
	
	var openImagePopupAction = exports.openImagePopupAction = function openImagePopupAction(popupData) {
	  return {
	    type: _constants.IMAGE_POPUP_OPEN,
	    payload: popupData
	  };
	};
	
	var closeImagePopupAction = exports.closeImagePopupAction = function closeImagePopupAction() {
	  return {
	    type: _constants.IMAGE_POPUP_CLOSE,
	    payload: false
	  };
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.brands = exports.other = exports.applications = exports.sites = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sgAnalitics = __webpack_require__(270);
	
	var _sgAnalitics2 = _interopRequireDefault(_sgAnalitics);
	
	var _sgAnalitics3 = __webpack_require__(264);
	
	var _sgAnalitics4 = _interopRequireDefault(_sgAnalitics3);
	
	var _sgAnalytics = __webpack_require__(271);
	
	var _sgAnalytics2 = _interopRequireDefault(_sgAnalytics);
	
	var _sgAnalytics3 = __webpack_require__(265);
	
	var _sgAnalytics4 = _interopRequireDefault(_sgAnalytics3);
	
	var _sgDocuments = __webpack_require__(272);
	
	var _sgDocuments2 = _interopRequireDefault(_sgDocuments);
	
	var _sgDocuments3 = __webpack_require__(266);
	
	var _sgDocuments4 = _interopRequireDefault(_sgDocuments3);
	
	var _sgMetrics = __webpack_require__(273);
	
	var _sgMetrics2 = _interopRequireDefault(_sgMetrics);
	
	var _sgMetrics3 = __webpack_require__(267);
	
	var _sgMetrics4 = _interopRequireDefault(_sgMetrics3);
	
	var _sgPm = __webpack_require__(274);
	
	var _sgPm2 = _interopRequireDefault(_sgPm);
	
	var _sgPm3 = __webpack_require__(268);
	
	var _sgPm4 = _interopRequireDefault(_sgPm3);
	
	var _sgReports = __webpack_require__(275);
	
	var _sgReports2 = _interopRequireDefault(_sgReports);
	
	var _sgReports3 = __webpack_require__(269);
	
	var _sgReports4 = _interopRequireDefault(_sgReports3);
	
	var _vvsReportShow = __webpack_require__(296);
	
	var _vvsReportShow2 = _interopRequireDefault(_vvsReportShow);
	
	var _vvsReportShow3 = __webpack_require__(302);
	
	var _vvsReportShow4 = _interopRequireDefault(_vvsReportShow3);
	
	var _vvsReport = __webpack_require__(297);
	
	var _vvsReport2 = _interopRequireDefault(_vvsReport);
	
	var _vvsReport3 = __webpack_require__(303);
	
	var _vvsReport4 = _interopRequireDefault(_vvsReport3);
	
	var _vvsReport5 = __webpack_require__(298);
	
	var _vvsReport6 = _interopRequireDefault(_vvsReport5);
	
	var _vvsReport7 = __webpack_require__(304);
	
	var _vvsReport8 = _interopRequireDefault(_vvsReport7);
	
	var _vvsUsers = __webpack_require__(301);
	
	var _vvsUsers2 = _interopRequireDefault(_vvsUsers);
	
	var _vvsUsers3 = __webpack_require__(307);
	
	var _vvsUsers4 = _interopRequireDefault(_vvsUsers3);
	
	var _vvsReportsAdm = __webpack_require__(299);
	
	var _vvsReportsAdm2 = _interopRequireDefault(_vvsReportsAdm);
	
	var _vvsReportsAdm3 = __webpack_require__(305);
	
	var _vvsReportsAdm4 = _interopRequireDefault(_vvsReportsAdm3);
	
	var _vvsUser = __webpack_require__(300);
	
	var _vvsUser2 = _interopRequireDefault(_vvsUser);
	
	var _vvsUser3 = __webpack_require__(306);
	
	var _vvsUser4 = _interopRequireDefault(_vvsUser3);
	
	var _todo = __webpack_require__(276);
	
	var _todo2 = _interopRequireDefault(_todo);
	
	var _todo3 = __webpack_require__(282);
	
	var _todo4 = _interopRequireDefault(_todo3);
	
	var _todo5 = __webpack_require__(277);
	
	var _todo6 = _interopRequireDefault(_todo5);
	
	var _todo7 = __webpack_require__(283);
	
	var _todo8 = _interopRequireDefault(_todo7);
	
	var _todo9 = __webpack_require__(278);
	
	var _todo10 = _interopRequireDefault(_todo9);
	
	var _todo11 = __webpack_require__(284);
	
	var _todo12 = _interopRequireDefault(_todo11);
	
	var _todo13 = __webpack_require__(279);
	
	var _todo14 = _interopRequireDefault(_todo13);
	
	var _todo15 = __webpack_require__(285);
	
	var _todo16 = _interopRequireDefault(_todo15);
	
	var _todo17 = __webpack_require__(280);
	
	var _todo18 = _interopRequireDefault(_todo17);
	
	var _todo19 = __webpack_require__(286);
	
	var _todo20 = _interopRequireDefault(_todo19);
	
	var _todo21 = __webpack_require__(281);
	
	var _todo22 = _interopRequireDefault(_todo21);
	
	var _todo23 = __webpack_require__(287);
	
	var _todo24 = _interopRequireDefault(_todo23);
	
	var _gift = __webpack_require__(208);
	
	var _gift2 = _interopRequireDefault(_gift);
	
	var _gift3 = __webpack_require__(192);
	
	var _gift4 = _interopRequireDefault(_gift3);
	
	var _gift5 = __webpack_require__(209);
	
	var _gift6 = _interopRequireDefault(_gift5);
	
	var _gift7 = __webpack_require__(193);
	
	var _gift8 = _interopRequireDefault(_gift7);
	
	var _lamd = __webpack_require__(201);
	
	var _lamd2 = _interopRequireDefault(_lamd);
	
	var _lamd3 = __webpack_require__(194);
	
	var _lamd4 = _interopRequireDefault(_lamd3);
	
	var _land = __webpack_require__(202);
	
	var _land2 = _interopRequireDefault(_land);
	
	var _land3 = __webpack_require__(195);
	
	var _land4 = _interopRequireDefault(_land3);
	
	var _land5 = __webpack_require__(203);
	
	var _land6 = _interopRequireDefault(_land5);
	
	var _land7 = __webpack_require__(196);
	
	var _land8 = _interopRequireDefault(_land7);
	
	var _land9 = __webpack_require__(204);
	
	var _land10 = _interopRequireDefault(_land9);
	
	var _land11 = __webpack_require__(197);
	
	var _land12 = _interopRequireDefault(_land11);
	
	var _land13 = __webpack_require__(205);
	
	var _land14 = _interopRequireDefault(_land13);
	
	var _land15 = __webpack_require__(198);
	
	var _land16 = _interopRequireDefault(_land15);
	
	var _land17 = __webpack_require__(206);
	
	var _land18 = _interopRequireDefault(_land17);
	
	var _land19 = __webpack_require__(199);
	
	var _land20 = _interopRequireDefault(_land19);
	
	var _land21 = __webpack_require__(207);
	
	var _land22 = _interopRequireDefault(_land21);
	
	var _land23 = __webpack_require__(200);
	
	var _land24 = _interopRequireDefault(_land23);
	
	var _cosmoMain = __webpack_require__(212);
	
	var _cosmoMain2 = _interopRequireDefault(_cosmoMain);
	
	var _cosmoMain3 = __webpack_require__(210);
	
	var _cosmoMain4 = _interopRequireDefault(_cosmoMain3);
	
	var _mainAll = __webpack_require__(213);
	
	var _mainAll2 = _interopRequireDefault(_mainAll);
	
	var _mainAll3 = __webpack_require__(211);
	
	var _mainAll4 = _interopRequireDefault(_mainAll3);
	
	var _screencaptureSalesGeneratorRu2018072918_16_ = __webpack_require__(262);
	
	var _screencaptureSalesGeneratorRu2018072918_16_2 = _interopRequireDefault(_screencaptureSalesGeneratorRu2018072918_16_);
	
	var _screencaptureSalesGeneratorRu2018072918_16_3 = __webpack_require__(258);
	
	var _screencaptureSalesGeneratorRu2018072918_16_4 = _interopRequireDefault(_screencaptureSalesGeneratorRu2018072918_16_3);
	
	var _Screenshot_20180729_ = __webpack_require__(260);
	
	var _Screenshot_20180729_2 = _interopRequireDefault(_Screenshot_20180729_);
	
	var _Screenshot_20180729_3 = __webpack_require__(256);
	
	var _Screenshot_20180729_4 = _interopRequireDefault(_Screenshot_20180729_3);
	
	var _screencaptureSalesGeneratorRuCompany = __webpack_require__(263);
	
	var _screencaptureSalesGeneratorRuCompany2 = _interopRequireDefault(_screencaptureSalesGeneratorRuCompany);
	
	var _screencaptureSalesGeneratorRuCompany3 = __webpack_require__(259);
	
	var _screencaptureSalesGeneratorRuCompany4 = _interopRequireDefault(_screencaptureSalesGeneratorRuCompany3);
	
	var _Screenshot_20180729_5 = __webpack_require__(261);
	
	var _Screenshot_20180729_6 = _interopRequireDefault(_Screenshot_20180729_5);
	
	var _Screenshot_20180729_7 = __webpack_require__(257);
	
	var _Screenshot_20180729_8 = _interopRequireDefault(_Screenshot_20180729_7);
	
	var _slovo = __webpack_require__(249);
	
	var _slovo2 = _interopRequireDefault(_slovo);
	
	var _slovo3 = __webpack_require__(242);
	
	var _slovo4 = _interopRequireDefault(_slovo3);
	
	var _slovo5 = __webpack_require__(250);
	
	var _slovo6 = _interopRequireDefault(_slovo5);
	
	var _slovo7 = __webpack_require__(243);
	
	var _slovo8 = _interopRequireDefault(_slovo7);
	
	var _slovo9 = __webpack_require__(251);
	
	var _slovo10 = _interopRequireDefault(_slovo9);
	
	var _slovo11 = __webpack_require__(244);
	
	var _slovo12 = _interopRequireDefault(_slovo11);
	
	var _slovo13 = __webpack_require__(252);
	
	var _slovo14 = _interopRequireDefault(_slovo13);
	
	var _slovo15 = __webpack_require__(245);
	
	var _slovo16 = _interopRequireDefault(_slovo15);
	
	var _slovo17 = __webpack_require__(253);
	
	var _slovo18 = _interopRequireDefault(_slovo17);
	
	var _slovo19 = __webpack_require__(246);
	
	var _slovo20 = _interopRequireDefault(_slovo19);
	
	var _slovo21 = __webpack_require__(254);
	
	var _slovo22 = _interopRequireDefault(_slovo21);
	
	var _slovo23 = __webpack_require__(247);
	
	var _slovo24 = _interopRequireDefault(_slovo23);
	
	var _slovo25 = __webpack_require__(255);
	
	var _slovo26 = _interopRequireDefault(_slovo25);
	
	var _slovo27 = __webpack_require__(248);
	
	var _slovo28 = _interopRequireDefault(_slovo27);
	
	var _myrem = __webpack_require__(228);
	
	var _myrem2 = _interopRequireDefault(_myrem);
	
	var _myrem3 = __webpack_require__(224);
	
	var _myrem4 = _interopRequireDefault(_myrem3);
	
	var _myrem5 = __webpack_require__(229);
	
	var _myrem6 = _interopRequireDefault(_myrem5);
	
	var _myrem7 = __webpack_require__(225);
	
	var _myrem8 = _interopRequireDefault(_myrem7);
	
	var _myrem9 = __webpack_require__(230);
	
	var _myrem10 = _interopRequireDefault(_myrem9);
	
	var _myrem11 = __webpack_require__(226);
	
	var _myrem12 = _interopRequireDefault(_myrem11);
	
	var _myrem13 = __webpack_require__(231);
	
	var _myrem14 = _interopRequireDefault(_myrem13);
	
	var _myrem15 = __webpack_require__(227);
	
	var _myrem16 = _interopRequireDefault(_myrem15);
	
	var _vvs = __webpack_require__(288);
	
	var _vvs2 = _interopRequireDefault(_vvs);
	
	var _vvs3 = __webpack_require__(292);
	
	var _vvs4 = _interopRequireDefault(_vvs3);
	
	var _vvs5 = __webpack_require__(289);
	
	var _vvs6 = _interopRequireDefault(_vvs5);
	
	var _vvs7 = __webpack_require__(293);
	
	var _vvs8 = _interopRequireDefault(_vvs7);
	
	var _vvs9 = __webpack_require__(290);
	
	var _vvs10 = _interopRequireDefault(_vvs9);
	
	var _vvs11 = __webpack_require__(294);
	
	var _vvs12 = _interopRequireDefault(_vvs11);
	
	var _vvs13 = __webpack_require__(291);
	
	var _vvs14 = _interopRequireDefault(_vvs13);
	
	var _vvs15 = __webpack_require__(295);
	
	var _vvs16 = _interopRequireDefault(_vvs15);
	
	var _pg = __webpack_require__(237);
	
	var _pg2 = _interopRequireDefault(_pg);
	
	var _pg3 = __webpack_require__(232);
	
	var _pg4 = _interopRequireDefault(_pg3);
	
	var _pg5 = __webpack_require__(238);
	
	var _pg6 = _interopRequireDefault(_pg5);
	
	var _pg7 = __webpack_require__(233);
	
	var _pg8 = _interopRequireDefault(_pg7);
	
	var _pg9 = __webpack_require__(239);
	
	var _pg10 = _interopRequireDefault(_pg9);
	
	var _pg11 = __webpack_require__(234);
	
	var _pg12 = _interopRequireDefault(_pg11);
	
	var _pg13 = __webpack_require__(240);
	
	var _pg14 = _interopRequireDefault(_pg13);
	
	var _pg15 = __webpack_require__(235);
	
	var _pg16 = _interopRequireDefault(_pg15);
	
	var _pg17 = __webpack_require__(241);
	
	var _pg18 = _interopRequireDefault(_pg17);
	
	var _pg19 = __webpack_require__(236);
	
	var _pg20 = _interopRequireDefault(_pg19);
	
	var _medka = __webpack_require__(219);
	
	var _medka2 = _interopRequireDefault(_medka);
	
	var _medka3 = __webpack_require__(214);
	
	var _medka4 = _interopRequireDefault(_medka3);
	
	var _medka5 = __webpack_require__(220);
	
	var _medka6 = _interopRequireDefault(_medka5);
	
	var _medka7 = __webpack_require__(215);
	
	var _medka8 = _interopRequireDefault(_medka7);
	
	var _medka9 = __webpack_require__(221);
	
	var _medka10 = _interopRequireDefault(_medka9);
	
	var _medka11 = __webpack_require__(216);
	
	var _medka12 = _interopRequireDefault(_medka11);
	
	var _medka13 = __webpack_require__(222);
	
	var _medka14 = _interopRequireDefault(_medka13);
	
	var _medka15 = __webpack_require__(217);
	
	var _medka16 = _interopRequireDefault(_medka15);
	
	var _medka17 = __webpack_require__(223);
	
	var _medka18 = _interopRequireDefault(_medka17);
	
	var _medka19 = __webpack_require__(218);
	
	var _medka20 = _interopRequireDefault(_medka19);
	
	var _fmLogo = __webpack_require__(184);
	
	var _fmLogo2 = _interopRequireDefault(_fmLogo);
	
	var _kosmodostavkaLogo = __webpack_require__(185);
	
	var _kosmodostavkaLogo2 = _interopRequireDefault(_kosmodostavkaLogo);
	
	var _mrLogo = __webpack_require__(186);
	
	var _mrLogo2 = _interopRequireDefault(_mrLogo);
	
	var _santehLogo = __webpack_require__(187);
	
	var _santehLogo2 = _interopRequireDefault(_santehLogo);
	
	var _sdLogo = __webpack_require__(188);
	
	var _sdLogo2 = _interopRequireDefault(_sdLogo);
	
	var _sgLogo = __webpack_require__(189);
	
	var _sgLogo2 = _interopRequireDefault(_sgLogo);
	
	var _sportstyleLogo = __webpack_require__(190);
	
	var _sportstyleLogo2 = _interopRequireDefault(_sportstyleLogo);
	
	var _vvsLogo = __webpack_require__(191);
	
	var _vvsLogo2 = _interopRequireDefault(_vvsLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*Sites End*/
	
	/*Other End*/
	/*Sites Start*/
	
	/*Applications End*/
	/*Other Start*/
	
	/*Applications Start*/
	var sites = exports.sites = [{
	  vvsSite1: { thumb: _vvs2.default, full: _vvs4.default },
	  vvsSite2: { thumb: _vvs6.default, full: _vvs8.default },
	  vvsSite3: { thumb: _vvs10.default, full: _vvs12.default },
	  vvsSite4: { thumb: _vvs14.default, full: _vvs16.default }
	}, {
	  sdSite1: { thumb: _slovo2.default, full: _slovo4.default },
	  sdSite4: { thumb: _slovo14.default, full: _slovo16.default },
	  sdSite3: { thumb: _slovo10.default, full: _slovo12.default },
	  sdSite2: { thumb: _slovo6.default, full: _slovo8.default },
	  sdSite5: { thumb: _slovo18.default, full: _slovo20.default },
	  /*sdSite6: {thumb: sdSite6, full: sdSite6Big},*/
	  sdSite7: { thumb: _slovo26.default, full: _slovo28.default }
	}, {
	  medka1: { thumb: _medka2.default, full: _medka4.default },
	  medka2: { thumb: _medka6.default, full: _medka8.default },
	  /*medka3: {thumb:medka3, full: medka3Full},*/
	  medka4: { thumb: _medka14.default, full: _medka16.default },
	  medka5: { thumb: _medka18.default, full: _medka20.default }
	}, {
	  pgSite5: { thumb: _pg18.default, full: _pg20.default },
	  pgSite2: { thumb: _pg6.default, full: _pg8.default },
	  pgSite3: { thumb: _pg10.default, full: _pg12.default },
	  pgSite4: { thumb: _pg14.default, full: _pg16.default },
	  pgSite1: { thumb: _pg2.default, full: _pg4.default }
	}, {
	  myRemon1: { thumb: _myrem2.default, full: _myrem4.default },
	  myRemon2: { thumb: _myrem6.default, full: _myrem8.default },
	  myRemon3: { thumb: _myrem10.default, full: _myrem12.default },
	  myRemon4: { thumb: _myrem14.default, full: _myrem16.default }
	}, {
	  cosmoMain: { thumb: _cosmoMain2.default, full: _cosmoMain4.default },
	  cosmoMainAll: { thumb: _mainAll2.default, full: _mainAll4.default },
	  cosmoMainAll1: { thumb: _mainAll2.default, full: _mainAll4.default },
	  cosmoMain1: { thumb: _cosmoMain2.default, full: _cosmoMain4.default }
	}, {
	  sgSite1: { thumb: _screencaptureSalesGeneratorRu2018072918_16_2.default, full: _screencaptureSalesGeneratorRu2018072918_16_4.default },
	  sgSite2: { thumb: _Screenshot_20180729_2.default, full: _Screenshot_20180729_4.default },
	  sgSite4: { thumb: _Screenshot_20180729_6.default, full: _Screenshot_20180729_8.default },
	  sgSite3: { thumb: _screencaptureSalesGeneratorRuCompany2.default, full: _screencaptureSalesGeneratorRuCompany4.default }
	}];
	
	var applications = exports.applications = [{
	  sgAppAnalitycs: { thumb: _sgAnalitics2.default, full: _sgAnalitics4.default },
	  sgAppAnalitycs2: { thumb: _sgAnalytics2.default, full: _sgAnalytics4.default },
	  sgAppDocuments: { thumb: _sgDocuments2.default, full: _sgDocuments4.default },
	  sgAppMetrix: { thumb: _sgMetrics2.default, full: _sgMetrics4.default },
	  sgAppPm: { thumb: _sgPm2.default, full: _sgPm4.default },
	  sgAppReports: { thumb: _sgReports2.default, full: _sgReports4.default }
	}, {
	  vvsApp1: { thumb: _vvsReportShow2.default, full: _vvsReportShow4.default },
	  vvsApp2: { thumb: _vvsReport2.default, full: _vvsReport4.default },
	  vvsApp3: { thumb: _vvsReport6.default, full: _vvsReport8.default },
	  vvsApp4: { thumb: _vvsUsers2.default, full: _vvsUsers4.default },
	  vvsApp5: { thumb: _vvsReportsAdm2.default, full: _vvsReportsAdm4.default },
	  vvsApp6: { thumb: _vvsUser2.default, full: _vvsUser4.default }
	}, {
	  todo1: { thumb: _todo2.default, full: _todo4.default },
	  todo2: { thumb: _todo6.default, full: _todo8.default },
	  todo3: { thumb: _todo10.default, full: _todo12.default },
	  todo4: { thumb: _todo14.default, full: _todo16.default },
	  todo5: { thumb: _todo18.default, full: _todo20.default },
	  todo6: { thumb: _todo22.default, full: _todo24.default }
	}];
	
	var other = exports.other = [{
	  land1: { thumb: _lamd2.default, full: _lamd4.default },
	  land4: { thumb: _land10.default, full: _land12.default }
	}, {
	  land6: { thumb: _land18.default, full: _land20.default },
	  land7: { thumb: _land22.default, full: _land24.default },
	  land3: { thumb: _land6.default, full: _land8.default }
	}, {
	  gift1: { thumb: _gift2.default, full: _gift4.default },
	  gift2: { thumb: _gift6.default, full: _gift8.default },
	  land5: { thumb: _land14.default, full: _land16.default }
	}];
	
	var brands = exports.brands = [_fmLogo2.default, _sgLogo2.default, _mrLogo2.default, _santehLogo2.default, _vvsLogo2.default, _sdLogo2.default, /*sportstyleLogo, */_kosmodostavkaLogo2.default];

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(25),
	    getRawTag = __webpack_require__(69),
	    objectToString = __webpack_require__(70);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(71);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(25);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(67);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(66),
	    getPrototype = __webpack_require__(68),
	    isObjectLike = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(28);
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(26);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(89);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(83);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(84);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(85);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(86);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(18);
	
	var _wrapMapToProps = __webpack_require__(27);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(27);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(29);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(87);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(14);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(92);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(95)(module)))

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(147);
	var each = __webpack_require__(64).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(145);
	var Util = __webpack_require__(64);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(146);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(183);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(180);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(33);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(178);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(153);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(21);
	
	var _track = __webpack_require__(181);
	
	var _dots = __webpack_require__(176);
	
	var _arrows = __webpack_require__(174);
	
	var _resizeObserverPolyfill = __webpack_require__(182);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          currentSlide = _this$props.currentSlide,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(179);
	
	var _json2mq = __webpack_require__(152);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(175);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(148);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fm-logo.f86645b4.svg";

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXAAAADfCAMAAADY+niCAAAAP1BMVEVHcEz/5NJeXl6goKD/fSf/lE3/vI//ZgBAQED79/RLS0vJycmNjY3/cBB0dHT/sHr/y6fg4OCtra25ubmamppqq1PtAAAAAXRSTlMAQObYZgAADoxJREFUeNrtneuiqiAQhU27IcQO9f2fdZeWcpkZMLVQmV/ntK30c1gsBrAs+0Yc/liW4mvBzpfL7Z44fCsOx8szToeE4ivpfbq8I+nKF+J+uwxxTLqytJqcLmYkXVlUTf4uTtzOSVcWU5PjBYpjSvKlO0s7Uue5hPW+XfBIpnwh6z3IiM0/dZ6LdpYPDbFfuyVdWcZ6D9nsZH1K8kWs96DXjq6fUpLP0FlSjsR2LrdzIjZzZ3nwePOkK3Nab2hUaXWet2TKZ+8sfSKfKlozqcl96p1JMdJ6T9OeFKSajO0Lkylfxnp/6h9TkOg+G898cptSTBKH1HnO0FmO6v7GdbUpwnKUvaXiPs1MpghT4fvx9PrXDVKbVNGaVw+ejrsHjh+STPk81rtLXw041ghS5+lN75C0fK9x04AjNyZ1njNY756iCRymmSpao6z3nTQwNnBEV5Ipn9JZ6hnrAEfsY+o8gzrLk1eTAeDIXUoVrU+t9wUDfuvVH3qnU9HauykP6izdFbM6cE05oLaRKlpjmzywYtYErjcASFdS5zmqTgWtmLWBa8oB+ZtkykfUqcAVsw5wXTlAXUkVrSBtxVbMAsA9urL7ilaY9T4ii5NB4D5d2bUpD6pT4evvYeA+XdnvGi0H5TnAW4QA16BCi5ed791H5wkIMwtXEw9wTasAXTntceMEhJL5rXcocFJXAJHauimHUbJwNfEDJ3QF7BU23Xki+/4YOZAfDRzVldPOdh2iKFm4mgQBx3Tl1C9p3oMpdwt3Zxf4/XiZBbiuK4NmnPqc3kFFC6hT3W3g7HS5zAUc0pUe+PYrWqD1doD/XWYErunK0QW+8YoWnE9LA+91BQK+5YoWNoG+PPBXHsPAt1rRwtvuF4Bn2REHvs2KFlEy+j3w7VW0yBSKAfi2Ok+PSEYBfEvTzD4bEAnwrZhyf1uNBvgmOs+ArIkH+PrXaIWtp4oI+LrXaAVumYwK+Jo7z9DmGRnw1W6c+PN1QIdYga/UlJ/oLGF/x2iBr7OidSLP9+FeYga+xorWiWiRB/36owQerynnTjAL+PEAS2TkwGOtaF2dUPRl9Y01euBxdp5e4CesO4of+ONs72Yc1gZcF8Y1AI8wxgA3u/4E/LPxuxsYcMvcJuDL2MITYrMS8IWBO0szE/BlgV8S8AQ8su5Q8bqqqlqx/QK/n45GnOjxfZV3gR8kuwMql3Yty97oyQr4BFGWZQN/6OMvmwAOrSol5yOKFzCOFkJeBxT2NwnbXEvlYH28KsDb/Dx+E8DhVbx3P3CBHSBA4Ky4AiFYGHB13QrwQ3uQISrt+w5e4FdEU1gJAVd5D/kpN/1/Sh4CnMnNAH9OyZ5dkbmd/MAr+O/1FQDOX3chL7pCK1OVhO4LAvz1nVsA/gftrHt80I1RwNsMlUiXeX0dUDiyLo10Vi/tabzA1XXbwNsXDxRwKbSCEgBHSAN4B6ysnWNzu6mAwFm+deBPYf8jgSvIhgx2ghvAO1WX0MPrhGV4QODNdevAn992JIFnz6QDrXj7h8wALjHeb3UuGQVcXbcC/Fn1bNWjr37qXvFAAq8QK847jdCBVwTvl4kUBPBOUIqfAGd0jAF++DPryLejvZz9TAJniBUXnWHUgLeCUqJ9cOf4OA68uyPqF8BDIhD4Afi825DTzJ02tIC/yUImXGQ68IIclj4Uo9Qcjwu8bTI5WzlwBm7K1azgCZR2HXhLoAZNONeBsxJ3kNodUQjwTlBUtnLgd/jNZ2M8dCeBt72jhEx4nunAa0+CD60CBC5edmjlwM/0l5HG8A28Aqy4etvqAfj7FhDRDCJvA6+vLze0cuB/9Js7x3OkgTPAildvYe+Bt+lb0cDVcOss4J2DV9mPgN8OdNxmBI4PNt/A29aeuyZcZDpwhQ5JtRhuigVc9gNRtW4f7gd+QI1hD1w56jy80gN/akLpKxEPmE3g9VCy2Txwhg42e+BDPus9XJ4ZwAufR3mLuHSBt4axVPsAjhvDAWFlWXFmSkNhsqRm7YwbJYwhUZ3tBPgdM4YDcGZZ8Xq4AT1wQc0N0cArvQa8feDoYFMTCWGmrzT99MQMV0ZZa/vAM2wWQgNuWhCmdaLTNbwbYvJsP8DPiDHUERoTO4VmE6e7lMKsju0AODbY1IFXuhXPtSHOOB+euz7cFJRdAMcGmzpwXUWU7lmmjjQtQdkHcGSwaaiyZkKEPZEw1FI8Il64tRRhzy7vATgyC2EAH9K6TWXuAq+9msJyp1rIr/YM3h6AI8bQ9B3524rXRmVlTD28styN6IvgOwOODDZN4NX7f9LQam3Gp/EUxNs7kht+RbiFyF0Ah2chTODslYvMHObbc5rUWltnTpMDs867AH4ANcUayogObeXWVcNm7QtjEVcLvMSmNrYOvB1s+oCrThByUzd04F0RSjBcwEtlpDu0cHEfwEFjaA/WW9TKmowwFgIpfOVVt6iqzmzgMtslcHCwaQNvxURYSWmuLezWcuZOz6mkvZrzBdxdxrIP4OAshA382V2WpbVIRYKrZ4UC0tuo3r6A19k+gYPG0Kn/CWBHhLTXh/cbe17MWf3eKNE4lgUqoO8EODQL4QDnwJ4fie+AKHMp82FvVe16RMhD7gQ4NNh0K9wtyzwjgfcCQm+rktgoaSfAnx9jz0K4wCvXx0lg+bhyd7FxvDIeBfDZVs8GAwcGm7WU0mTCHq9Ypk88XnF7PtZv7Hk2iQYoaYk8h4dI6rkVa8srrzyzEB8HU3XRNEXF17AT+QfAiSVvP4ntAyf3VyXg8wOn9kIk4AsAp/ZCRADcXdGKAWeHwEA/mT5+LuDUXogIgKPhAP/WmU0GTuyFSMCXAB6XpuwAeEZuvE/A5wcelTHcA/DZB5sJOA2c3SIabO4BOLnxPgFfALgx2Dz8NLLA39ldSyD7xJ9/6RLlcPztCe4DeDsL0f08xN8lAf8C8FYPb6dHHBPwWQPriv5iOcGtAUft9jkBXyKIEbz9AKEEfI64B5vNBHwOAQ8Y3Nx/Dfx+3kjc72EjssNvrzhLkSJFihQpUqRIkSJFihQpUqRIkSJFihQpUqw32p8ZLYqiqrliMZ1YgcXjTL0nyouwqJA3qeDTVMObuP/gSuTGfuFcVCocBXlQBRykivDIrlSU4G+iDiGuYWHsYq+0jdPBwLVvKny3JofPoQh5yr33safDj6ppKXQNj8x7hOTLAb+Gpri6BgLn8sNLiQc49Byc2YCLQOBNGHAlfdmj1gAcP8/JwMuw/oyVIcBZyOkItgbgpftDkvMA9z1E9xX1NQA4z8POha8AOHaZ04HnQSmeBwCv3DRpfyq9dF6uVgEcbItC+1FmKgROhgfw5v5bb8lJ+fCB/Y5pxyUisvI5cPeKjXuuR9Z34E44p4kD59mIMIGHOEPpBW7yFs4IgnHhJ/4xcOB8oKbdBfRgsuF9VU5e6QzAA5yh8oqbwVvAn2g8sQok/lXgmD9jdU40/zmA+51h4wWu8c5VkGkUsQI3sscxcXMAv/q6TVb6gFdBrs88sIpSUuzTFEsAL6Yer8K7YN7fvFLFmuGGDeYzApeBzjC3jreBs+EBjgF1rRw3pPEAH5JMzgi875DrIE9Y1gjwZpTFVH2ONxEDH3olNR/wughyhu/EbjgMXI3irR3viEo0Gq53XGJG4CzEGfZ8FAJcXMMuwW2uIuIM78/SNCrTgPdvFwFtS2Qw8P6GyOB5HYmkeFTA+xTnMwJXfmeofS8MvBlbWtfuURMx8P7CxIzAM+l1htVw5iBwROvCrsUyKjFp+JAW+ZzAa68z1JwMCJyPT/ABh3XecWU4eDpTgTOfM+Ra1wECFx8kOPauyIBLIJWmAs98zlBqDRAEXn5yBv1H5TEDF0sA9zhDpf8ZAq7GTdU5ys/i1fA+GfmcwD2SIPQGAAGvPlKUoeXwiDO8IoBfSzJyHDjpDM3ODQIuRk2NutkDylPYVNniwKkM981B48BJZ1gZpw0Blx9J+PBZImLglIZPAF7jKmx5GAh4HlhTxzoHGTFwuQxwwhly815AwMugyw8EEhlw6NpmAN5LVU56QgQ4fl2eiB84OdKcApxh1VVlWcadAW8g/zgHcNQZCktnAeBsu8B7qQWrhaKmgwSu4MGPk/lfy3BORfkl4IvUw2GtzhBtnxM41WlGMfBZZMbn/QLoDPsmVVHAP3UplC3c7pwm4rexuzCnD6cGPpudta9x9QB1hhrajx1pFlBJYOvrUmpqQgDoSSHgTeBionUVr+plVl7VuAOEXgGB16N3Z8VSnv3B2sIaH+OAoyEIOPusHh7zBMRyq2dr4DIaQtXBGZ+w1VurmWJbdH044UlcT5h55jRHaUoMk8g/2AFR464bdOYgcPXJrH0RwTKJaXt8JgO3NCSH7jG8ECgfn+LYWpa4gDeUFk4HbrRyOG1h4NV19Dkgo7iogHv2aU4HbogxLMww8D5dg40Kj2Ix57SdyDMA17Ia6dOQ1bPFyCclDDtYVKzA/XvtZwCu6TYyB4QAHzZABK1XHg4XWZzAQ54mMQfwwZmU8NoHBLi2bTZggM9kJFtOEOmW9INd5gTec5aIKGPAtXmnJpw3cM5fBZ5DTwTyets5gQ9ijDR5FPigEp5dg9qWKmhUEdnKq8WBsyu9RRkFrm2UovbFGg+lgPZL7A24NSUts2DgxtMP0CTXNyLn0W79/iZwTj9mggBuvLVsoCxXwvvQkBUBb7gngoAbj0XJszHAtS3Gbeuw+nrrwWP5zI/v+D7wjx5QU1MaC6yHJYHr/WH3lVI8un3O60pIa8EJtt9tf8C1xxgAA3UauO74PFUhTOT3B1zbxS2yscAzVl0nDZv3CFxRj63h3vGkEp+n9z6BkxM4PGAAz2ldEeRQbo/AOeEzeVDFBM9y2C5+HfhrG85nwJsyLIyErV4vgiV2CWwK6p1fF74SFauFuw42F/5HF+cl/uX2QaWvBgxc+JZD1Y3oHllYPvxhUbMsRYoU34h/YI0GYQmpY1kAAAAASUVORK5CYII="

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/santeh-logo.25a6c1b5.png";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-logo.7ae2040f.svg";

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gift1.d9076917.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gift2.98063bd5.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lamd1.b8376660.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land2.b8376660.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land3.0836c0aa.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land4.892acd85.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land5.9211b43f.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land6.c1fa671a.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land7.f3d137ca.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lamd1.b8376660.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land2.b8376660.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land3.0836c0aa.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land4.892acd85.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land5.9211b43f.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land6.c1fa671a.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/land7.f3d137ca.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gift1.d9076917.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gift2.98063bd5.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cosmo-main.82dd012b.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/main-all.81a6204e.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cosmo-main.82dd012b.png";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/main-all.81a6204e.png";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka1.76fe9607.png";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka2.bd527dc8.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka3.a14d5281.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka4.745fb653.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka5.43bb44a1.png";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka1.76fe9607.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka2.bd527dc8.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka3.a14d5281.png";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka4.745fb653.png";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medka5.43bb44a1.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem1.cbdc030f.png";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem2.8723f035.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem3.05253aa9.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem4.8db7879f.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem1.cbdc030f.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem2.8723f035.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem3.05253aa9.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/myrem4.8db7879f.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg1.d97fdd7b.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg2.59264eca.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg3.37f5d459.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg4.81eeff5c.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg5.6eb66e75.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg1.d97fdd7b.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg2.59264eca.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg3.37f5d459.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg4.81eeff5c.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pg5.6eb66e75.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo1.61864ab4.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo2.b9bd6dc8.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo3.51a5582c.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo4.8376458c.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo5.fe437c4f.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo6.9f58b305.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo7.c42037e8.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo1.61864ab4.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo2.b9bd6dc8.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo3.51a5582c.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo4.8376458c.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo5.fe437c4f.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo6.9f58b305.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/slovo7.c42037e8.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Screenshot_2018-07-29_18-29-42.eb3dfa4b.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Screenshot_2018-07-29_18-31-22.fa5d9854.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screencapture-sales-generator-ru-2018-07-29-18_16_.38d74191.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screencapture-sales-generator-ru-company-2018-07-2.0723e4f1.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Screenshot_2018-07-29_18-29-42.eb3dfa4b.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Screenshot_2018-07-29_18-31-22.fa5d9854.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screencapture-sales-generator-ru-2018-07-29-18_16_.38d74191.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screencapture-sales-generator-ru-company-2018-07-2.0723e4f1.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-analitics.b15989c1.png";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-analytics2.fc34df6d.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-documents.bedaee0e.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-metrics.1ff8e1bd.png";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-pm.f73895bc.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-reports.6b36e52a.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-analitics.b15989c1.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-analytics2.fc34df6d.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-documents.bedaee0e.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-metrics.1ff8e1bd.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-pm.f73895bc.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sg-reports.6b36e52a.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo1.5672ffaf.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo2.892a017b.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo3.479eafd0.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo4.479eafd0.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo5.987f3daf.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo6.a1ca9318.png";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo1.5672ffaf.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo2.892a017b.png";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo3.479eafd0.png";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo4.479eafd0.png";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo5.987f3daf.png";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo6.a1ca9318.png";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs1.e831b156.png";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs2.0212cd24.png";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs3.c3e745aa.png";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs4.5f0424ce.png";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs1.962d3bc3.png";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs2.dd68fe3f.png";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs3.c55fe5ac.png";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs4.92cd4fb9.png";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report-show.1a346489.png";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report2.e6ebd579.png";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report3.e6ebd579.png";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-reports-adm.1391544c.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-user.81f1885f.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-users.96bb83ce.png";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report-show.1a346489.png";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report2.e6ebd579.png";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-report3.e6ebd579.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-reports-adm.1391544c.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-user.81f1885f.png";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vvs-users.96bb83ce.png";

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mapDispatchToProps = undefined;
	exports.mapStateToProps = mapStateToProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _images = __webpack_require__(54);
	
	var _reactSlick = __webpack_require__(177);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Tags = __webpack_require__(402);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _actions = __webpack_require__(53);
	
	var _redux = __webpack_require__(18);
	
	var _reactRedux = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorksList = function (_React$Component) {
	  _inherits(WorksList, _React$Component);
	
	  function WorksList() {
	    _classCallCheck(this, WorksList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WorksList.prototype.componentDidMount = function componentDidMount() {
	    console.log(this.props);
	  };
	
	  WorksList.prototype.tagClickHandler = function tagClickHandler(event) {
	    console.log(event.target.getAttribute('data-tag'));
	  };
	
	  WorksList.prototype.workImageClickHandler = function workImageClickHandler(event) {
	    var fullImage = event.target.getAttribute('data-full-image');
	    this.props.openImagePopupAction({ isOpen: true, image: fullImage });
	  };
	
	  WorksList.prototype.render = function render() {
	    var _this2 = this;
	
	    var worksData = this.props['works-data'];
	    var settings = {
	      dots: true,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 4,
	      slidesToScroll: 4,
	      centerMode: false,
	      centerPadding: "20px",
	      arrows: false,
	      lazyLoad: 'ondemand',
	      autoplay: true,
	      autoplaySpeed: 5000,
	      responsive: [{
	        breakpoint: 768,
	        settings: {
	          dots: true,
	          infinite: true,
	          speed: 500,
	          slidesToShow: 2,
	          slidesToScroll: 2,
	          centerMode: false,
	          centerPadding: "20px",
	          arrows: false,
	          lazyLoad: 'ondemand',
	          autoplay: true,
	          autoplaySpeed: 5000
	        }
	      }]
	    },
	        worksSettings = {
	      dots: true,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 3,
	      slidesToScroll: 3,
	      centerMode: false,
	      centerPadding: "20px",
	      arrows: true,
	      lazyLoad: 'ondemand',
	      autoplay: false,
	      autoplaySpeed: 5000,
	      responsive: [{
	        breakpoint: 768,
	        settings: {
	          dots: true,
	          infinite: true,
	          speed: 500,
	          slidesToShow: 2,
	          slidesToScroll: 2,
	          centerMode: false,
	          centerPadding: "20px",
	          arrows: false,
	          lazyLoad: 'ondemand',
	          autoplay: false,
	          autoplaySpeed: 5000
	        }
	      }]
	    };
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'portfolio' },
	      _react2.default.createElement(_Tags2.default, { click: this.tagClickHandler.bind(this) }),
	      _react2.default.createElement(
	        'section',
	        { className: 'work-data' },
	        worksData.map(function (work, key) {
	          if (work.node.frontmatter.section === 'portfolio') {
	            return _react2.default.createElement(
	              'div',
	              { className: 'work-data__item', key: key },
	              _react2.default.createElement(
	                'h5',
	                null,
	                work.node.frontmatter.appName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                  'blockquote',
	                  null,
	                  '\u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438: ',
	                  work.node.frontmatter.tags.map(function (tag, key) {
	                    if (tag !== 'bitrix' && tag !== 'django' && tag !== 'express' && tag !== 'modx') {
	                      return _react2.default.createElement(
	                        'i',
	                        { key: key, className: 'fi fi-' + tag + ' tags-filter__item', 'data-tag': tag },
	                        ' '
	                      );
	                    } else {
	                      return _react2.default.createElement(
	                        'i',
	                        { className: tag + '-icon tags-filter__item', key: key, 'data-tag': tag },
	                        ' '
	                      );
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  work.node.frontmatter.description
	                )
	              ),
	              _react2.default.createElement(
	                _reactSlick2.default,
	                worksSettings,
	                work.node.frontmatter.imagesThumb.map(function (thumb, i) {
	                  return _react2.default.createElement('img', { src: thumb.childImageSharp.resolutions.src,
	                    'data-full-image': work.node.frontmatter.imagesFull[i].childImageSharp.resolutions.src,
	                    key: i,
	                    onClick: _this2.workImageClickHandler.bind(_this2) });
	                })
	              )
	            );
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        '\u0420\u0430\u0431\u043E\u0442\u0430\u043B \u0441 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u043C\u0438:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio-brands' },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          _images.brands.map(function (brand, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'portfolio-brands__item' },
	              _react2.default.createElement('img', { src: brand })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return WorksList;
	}(_react2.default.Component);
	
	function mapStateToProps(store) {
	  return {};
	}
	
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ openImagePopupAction: _actions.openImagePopupAction }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WorksList);

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var click = _ref.click;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'tags' },
	    _react2.default.createElement(
	      'p',
	      { className: 'tags-filter' },
	      '\u0424\u0438\u043B\u0442\u044C\u0442\u0440 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0439:',
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-react tags-filter__item', 'data-tag': 'react', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-vuejs tags-filter__item', 'data-tag': 'vuejs', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-nodejs tags-filter__item', 'data-tag': 'nodejs', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-python tags-filter__item', 'data-tag': 'python', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-php tags-filter__item', 'data-tag': 'php', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-wordpress tags-filter__item', 'data-tag': 'wordpress', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'fi fi-android tags-filter__item', 'data-tag': 'android', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'bitrix-icon tags-filter__item', 'data-tag': 'bitrix', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'django-icon tags-filter__item', 'data-tag': 'django', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'express-icon tags-filter__item', 'data-tag': 'express', onClick: click },
	        ' '
	      ),
	      _react2.default.createElement(
	        'i',
	        { className: 'modx-icon tags-filter__item', 'data-tag': 'modx', onClick: click },
	        ' '
	      )
	    )
	  );
	};
	
	exports.default = Tags;
	module.exports = exports['default'];

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(80);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _FlyContainer = __webpack_require__(55);
	
	var _FlyContainer2 = _interopRequireDefault(_FlyContainer);
	
	var _TitleImage = __webpack_require__(56);
	
	var _TitleImage2 = _interopRequireDefault(_TitleImage);
	
	var _WorksList = __webpack_require__(399);
	
	var _WorksList2 = _interopRequireDefault(_WorksList);
	
	var _favicon = __webpack_require__(93);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var Portfolio = function (_React$Component) {
	  _inherits(Portfolio, _React$Component);
	
	  function Portfolio() {
	    _classCallCheck(this, Portfolio);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Portfolio.prototype.render = function render() {
	    var data = this.props.data.site.siteMetadata,
	        works = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      _FlyContainer2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: data.portfolio.title,
	        meta: [{ name: 'description', content: data.portfolio.description }, { name: 'keywords', content: data.keywords }, { name: 'theme-color', content: '#881F62' }, { name: 'background', content: '#881F62' }, { name: 'lang', content: 'ru' }],
	        link: [{ rel: 'shortcut icon', type: 'image/png', href: '' + _favicon2.default }]
	      }),
	      _react2.default.createElement(_TitleImage2.default, { type: 'portfolio' }),
	      _react2.default.createElement(
	        'h1',
	        { className: 'main-header' },
	        '\u041F\u043E\u0440\u0442\u0444\u043E\u043B\u0438\u043E'
	      ),
	      _react2.default.createElement(_WorksList2.default, { 'works-data': works })
	    );
	  };
	
	  return Portfolio;
	}(_react2.default.Component);
	
	exports.default = Portfolio;

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-56f113811739dfc974c9.js